import {Component, OnInit} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Modal} from "flowbite";
import {ActivatedRoute, Router} from "@angular/router";
import {PBSelectUser, PBTopic, PocketbaseService} from "../../services/pocketbase.service";
import {ReasonService} from "../../services/reason.service";

@Component({
  selector: 'app-edit-reason',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './edit-reason.component.html',
  styleUrl: './edit-reason.component.css'
})
export class EditReasonComponent implements OnInit{
  title = new FormControl('');
  description = new FormControl('');

  topicId?: String;
  topicName:String = "";
  users: PBSelectUser[] = []
  selectedUser?: PBSelectUser;
  topics: PBTopic[] = []
  reasonId: String = "";

  constructor(private reasonService: ReasonService, private router: Router, private pocket: PocketbaseService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.pocket.getAllUser().then(p=>{
      this.users = p;
    })

    this.pocket.getAllTopics().then(p=>{
      this.topics = p;
    })

    let id = this.route.snapshot.paramMap.get('id') ?? "";

    this.reasonService.getReason(id).then(reason => {
      this.reasonService.getTopic(reason.topic).then(topic=> {
        if (topic!=null){
          this.topicId = topic.id
          this.topicName = topic.topicname
        }
      })
      this.reasonService.getUserById(reason.forUser).then(user=>this.selectedUser = user)
      this.title = new FormControl(reason.title as string)
      this.description = new FormControl(reason.description as string)
      this.reasonId = reason.id
      const modalEl = document.getElementById('edit-popup');
      const privacyModal = new Modal(modalEl, {
        placement: 'center'
      });

      privacyModal.show();
      const route = (route: String)=>{
        this.router.navigate([route])
      }
      const updateReason = ()=>{
        return this.update()
      }
      const closeModalEl = document.getElementById('close-modal');
      closeModalEl?.addEventListener('click', function() {
        privacyModal.hide();
        route("/reason-board");
      });

      const saveReasonEl = document.getElementById('save-button');
      saveReasonEl?.addEventListener('click', function() {
        updateReason().then(()=>{
          privacyModal.hide();
          route("/create")
        });
      });
    })
  }

  update(){
    if (this.selectedUser===undefined){
      this.selectedUser = {id:"", username:"Jeder", avatar:""}
    }
    return this.reasonService.updateReason(this.reasonId,this.title.value?.toString()??"", this.description.value?.toString()??"", this.topicId??"", this.selectedUser!)
  }

  selectChange( $event : any) {
    this.selectedUser = this.users.find(p=>p.username == $event.target.value);
  }

  selectTopicChange($event: any) {
    this.topicId = this.topics.find(p=>p.topicname==$event.target.value)?.id ?? ""
  }

}
